import { useState, useContext, useEffect } from "react"
import { useParams, useLocation } from "react-router-dom"

import Error404 from "../../components/Error404/Error404"
import Error404Wrapper from "../../components/Error404/Error404Wrapper/Error404Wrapper"
import { AppContext } from "../../context/AppContext"
import Configuration from "../../helpers/configuration/Configuration"
import {
  setSelectedModel,
  getSelectedModel,
} from "../../hooks/use-selected-model"
import Configure from "./Configure"

const ConfigureStandard = () => {
  const params = useParams()
  const { store, setStore } = useContext(AppContext)
  const location = useLocation();
  const [ready, setReady] = useState(false)

  useEffect(() => {
    const selectedModel = getSelectedModel()
    if (
      params.MODELO &&
      store[params.MODELO] &&
      selectedModel !== params.MODELO
    ) {
      const modeloData = store[params.MODELO]

      setSelectedModel(params.MODELO)
      setStore(prevStore => ({
        ...prevStore,
        categories: modeloData.categories,
        defaults: modeloData.defaults,
        incompatibilities: modeloData.incompatibilities,
        predesigns: modeloData.predesigns,
        variables: modeloData.variables,
      }))
      setReady(true)
    } else if((location.state?.from === "summary" || location.state?.from === "menu") && selectedModel === params.MODELO){
      setReady(true)
    }
  }, [params.MODELO, store, setStore, location.state?.from])

  // Don't init the values until the predesigns have been loaded
  if (!store.predesigns || !ready) {
    if(!ready){
      return null
    }else{
      return (
        <Error404Wrapper>
          <Error404 />
        </Error404Wrapper>
      )
    }
    
  }

  const configuration = new Configuration().setParams(params).setStore(store)

  return (
    <Configure
      initialValues={configuration.getValues()}
      valid={configuration.isValid()}
      {...(params.MODELO ? { model: params.MODELO } : {})}
    />
  )
}

export default ConfigureStandard
